import { Overline } from "./Primitives";
import { FadeIn } from "./FadeIn";

export const PageHeader = ({ eyebrow, title, intro, image }) => (
  <section className="relative bg-amf-navy">
    {image && (
      <>
        <img
          src={image}
          alt=""
          aria-hidden="true"
          className="absolute inset-0 w-full h-full object-cover opacity-25 amf-img"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-amf-navy/70 to-amf-navy" />
      </>
    )}
    <div className="relative max-w-[1200px] mx-auto px-6 md:px-10 py-20 md:py-28">
      <FadeIn className="max-w-3xl">
        {eyebrow && <Overline light className="block mb-4">{eyebrow}</Overline>}
        <h1 className="font-playfair text-4xl sm:text-5xl lg:text-6xl leading-[1.1] text-amf-cream">
          {title}
        </h1>
        {intro && (
          <p className="font-lora text-lg text-amf-cream/85 mt-6 leading-relaxed max-w-2xl">
            {intro}
          </p>
        )}
      </FadeIn>
    </div>
  </section>
);
